// src/components/EmailSchedulerButton.jsx
// User-actionable email work. Operational diagnostics live on Admin Operations.

import React from 'react';
import { MdOutlineRateReview } from 'react-icons/md';
import { auth } from '../firebase';
import { useDeadLetterReviews } from '../hooks/useDeadLetterReviews';
import '../styles/EmailSchedulerButton.css';

const EmailSchedulerButton = ({ clients = [], onReviewDraft }) => {
  const uid = auth.currentUser?.uid;
  const { reviewItems } = useDeadLetterReviews(uid);
  const clientNames = new Map(clients.map(client => [client.id, client.name || client.clientName || 'Campaign']));

  if (reviewItems.length === 0) return null;

  return (
    <div className="dashboard-health-widget">
      <div className="email-sync-section">
        <section className="sync-work-panel sync-work-panel--review" aria-label="Unsent reply drafts">
          <div className="sync-work-panel__heading">
            <MdOutlineRateReview aria-hidden="true" />
            <div>
              <strong>{reviewItems.length} unsent reply draft{reviewItems.length === 1 ? '' : 's'}</strong>
              <p>Automatic replies were off. These drafts were saved and were not sent.</p>
            </div>
          </div>
          <div className="sync-work-panel__items">
            {reviewItems.map(item => (
              <div className="sync-work-item" key={item.id}>
                <span>
                  <strong>{clientNames.get(item.clientId) || 'Campaign'}</strong>
                  {item.recipient ? ` · ${item.recipient}` : ''}
                </span>
                <button type="button" onClick={() => onReviewDraft?.(item)}>
                  Review draft
                </button>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default EmailSchedulerButton;
